// action
import {
  loginIn,
  signUp,
  ajaxUserInfo,
  ajaxProfileList,
  ajaxServiceList,
  ajaxLogout,
  ajaxRate,
  ajaxCCDInfo,
  ajaxBandwidthDetail
} from './getData';

// import moment from 'moment'

import {
  LOGIN_IN,
  GET_USER_INFO,
  GET_SERVICE_LIST,
  GET_PROFILE_INFO,
  GET_RATE_INFO
} from './mutation-types';
import router from '../router';

export default {
  async login({ commit }, params) {
    const res = await loginIn(params);
    if (res.code === 200) {
      commit(LOGIN_IN, true);
    } else {
      commit(LOGIN_IN, false);
    }
    return res;
  },
  // 退出
  async logout({ commit }) {
    const res = await ajaxLogout();
    commit(LOGIN_IN, false);
    router.push({ name: 'Login' });

    return res;
  },
  // 注册
  async ajaxSignUp({ commit }, params) {
    const res = await signUp(params);
    return res;
  },
  // 用户信息
  async getUserInfo({ commit }, params) {
    const res = await ajaxUserInfo(params);
    if (res.code === 200) {
      commit(GET_USER_INFO, res.data);
    } else {
      // window.location.href = '/login'
    }
  },
  // 获取服务列表
  async getServiceList({ commit }, params) {
    // const res = {"code":200,"data":{"serviceList":["gaotiebj02","gaotiemm","gaotiesh02","gaotiezj01","gaotiezj02"],"lineCount":300,"ports":[{"ip":["116.196.115.158"],"port":20000,"port_num":300}],"name":"gaotiebj02"}};
    const res = await ajaxServiceList(params);
    
    if (res.code === 200) {
      commit(GET_SERVICE_LIST, res.data);
    } else {
      commit(GET_SERVICE_LIST, {});
    }
    return res.data.name
  },
  // 获取日志
  async getProfileList({ commit }, params) {
    const res = await ajaxProfileList(params);
    if (res.code === 200) {
      commit(GET_PROFILE_INFO, res.data);
    } else {
      commit(GET_PROFILE_INFO, {});
    }
  },
  // 获取宽带
  async getRate({ commit }, params) {
    const res = await ajaxRate(params);
    return res.data;
  },
  // // 查询业务
  async getCCDInfo({ commit }, params) {
    const res = await ajaxCCDInfo(params);
    return res.data;
  },
  // // 查询业务
  async getBandwidthDetail({ commit }, params) {
    const res = await ajaxBandwidthDetail(params);
    return res.data;
  },
};

